import { Inject, Pipe, PipeTransform } from 'ng-metadata/core';
import { DateRangeService } from './date-range.service'

/**
 * @ngdoc filter
 * @name mwDateRangeThisMonth
 * @module mw.components.dateRange
 *
 * @param {Date} relativeDate - Relative date.
 * @param {string} [format] - Formatting rules (see momentjs formatting rules https://momentjs.com/docs/#/displaying/format/). If not specified, 'MMM D' is used.
 * @param {string} [timezone] - Timezone to be used for formatting the date range. Valid momentjs
 *    timezones (see https://momentjs.com/timezone/docs/#/using-timezones/parsing-in-zone/) are supported.  If not specified, the timezone of the browser will be used.
 * @param {string} [locale] - Locale used for formatting the date range.  If not specified, the browser locale will be used.
 *
 * @returns {string} Formatted date range string.
 *
 * @description
 * `mwDateRangeThisMonth` filter converts a relative `Date` object to a `DateRange` and formats it to a string.  Start Date will the first day of the month that the `relativeDate` input is in.  End Date will be the `relativeDate` input.
 *
 */
@Pipe({ name: 'mwDateRangeThisMonth' })
export class DateRangeThisMonthPipe implements PipeTransform {
    private mwDateRangePipe;

    constructor(
        @Inject('mwDateRangeService') private dateRangeService: DateRangeService,
        @Inject('$filter') private $filter: any) {
        this.mwDateRangePipe = $filter('mwDateRange');
    }

    transform(date: Date, format: string, timezone: string, locale: string): string {
        return this.mwDateRangePipe(this.dateRangeService.thisMonth(date, timezone), format, timezone, locale);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/date-range/date-range-this-month.pipe.ts